import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography } from "@mui/material";
import { t } from '@lingui/macro';
import StyledButton from '../components/StyledButton';
import QrScanner from 'qr-scanner';
import { ReactComponent as QRScanFigure } from '../assets/qrScanFigure.svg';
import CheckoutHeader from '../components/CheckoutHeader';
import appRoutes from '../utils/routes';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks';
import orderSlice from '../store/orderSlice';

const videoElementId = 'code-viewer';
let qrScannerInstance: QrScanner | undefined;
let deviceCameraHandles: QrScanner.Camera[] = [];
let currentCameraIndex: number = 1;

const TableSelectionScreen: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [tableNumber, setTableNumber] = useState<number | undefined>()
    const [showScanner, setShowScanner] = useState<boolean>(false)

    const startScanning = async () => {
        const videoElement: HTMLVideoElement | null = document.getElementById(videoElementId) as HTMLVideoElement
        if (videoElement !== null) {
            qrScannerInstance = new QrScanner(
                videoElement,
                (result: QrScanner.ScanResult) => {
                    const url = new URL(result.data);
                    const query = new URLSearchParams(url.search)
                    if (query.has('table')) {
                        qrScannerInstance && qrScannerInstance.stop()
                        setTableNumber(Number(query.get('table')));
                        setShowScanner(false)
                    }
                },
                {
                    highlightScanRegion: true,
                    highlightCodeOutline: true,
                }
            );
        }
        if (qrScannerInstance) {
            deviceCameraHandles = await QrScanner.listCameras(true);
            qrScannerInstance.setCamera(deviceCameraHandles[currentCameraIndex]?.id || deviceCameraHandles[0]?.id);
            qrScannerInstance.start().then(() => {
            })
        } else {
            throw new Error('Cant start scan withiut qrScannerInstance')
        }
    }

    useEffect(() => {
        showScanner && startScanning()
        return () => { qrScannerInstance && qrScannerInstance.stop() }
    }, [showScanner])

    return <Box sx={{ height: '100vh' }}>
        <CheckoutHeader
            restaurantName={'resto staging'}
            headerTitle={t`Your order`}
            redirectUrl={appRoutes.checkout}
        />
        <Box height={'calc(100% - 140px)'}>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <Box py={'12px'} >
                    <Typography>{t`Scan QR Code at your table`}</Typography>
                </Box>
                {showScanner ?
                    <Box height={340} width={340} display={'flex'} justifyContent={'center'} alignContent={'center'} overflow={'hidden'}>
                        <video id={videoElementId} />
                    </Box>
                    : <>
                        <QRScanFigure />
                        <Box pb={'20px'} />
                        <StyledButton
                            color='warning'
                            fullWidth
                            onClick={() => {
                                setShowScanner(true);
                            }}
                            sx={{ backgroundColor: '#fff2ea' }}
                        >
                            {t`Open camera`}
                            <CameraAltIcon sx={{ ml: '8px' }} />
                        </StyledButton>
                    </>}
                <Box pb={'20px'} />
                <Typography>
                    {t`Or enter a table number manually.
Number is located on QR Code sticker at your table.`}
                </Typography>
            </Box>
            <Box pb={'20px'} />
            <TextField
                placeholder={t`Table number`}
                fullWidth
                value={tableNumber}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const tableNumber = Number(event.target.value);
                    if (!Number.isNaN(tableNumber)) {
                        setTableNumber(tableNumber)
                    }
                }}
            />
        </Box>
        <Box pb={'10px'} />
        <StyledButton
            variant='contained'
            disabled={!tableNumber}
            fullWidth
            onClick={() => {
                dispatch(orderSlice.actions.changeDineInPlace(String(tableNumber)));
                navigate(appRoutes.checkout)
            }}
        >
            {t`Confirm`}
        </StyledButton>
    </Box>
}
export default TableSelectionScreen;